import { PATH_SEGMENTS, ROUTES } from 'helpers/constants/routes';
import { NavigationInfo, useNavigationStore } from 'stores/navigation';

export function getPathSegments(pathname: string) {
  return pathname.split('/').filter(Boolean);
}

export function buildBreadcrumb(pathname: string, translate: any) {
  const segments = getPathSegments(pathname);
  const trail: NavigationInfo[] = [];

  //url without locale
  const currentPath = `/${segments.slice(1).join('/')}`;
  const parentRoute = useNavigationStore.getState().navigation;
  if (isHomePage(pathname)) {
    return trail;
  }

  if (segments[1] === PATH_SEGMENTS.RETAILERS) {
    const isRetailerDetailPage = segments.length > 2;
    if (!isRetailerDetailPage) {
      trail.push({ name: segments.at(1) ?? '', href: ROUTES.RETAILERS_ROUTE, isSearchable: true }); //isSearchable object is going to find the original category name from the categories data
    } else {
      // e.g., /en/retailers/zales/
      const retailerName = decodeURIComponent(segments[2]);
      const filteredParent = parentRoute.filter((i) => !i?.isRetailer);
      trail.push(...filteredParent, { name: capitalize(retailerName), isRetailer: true });
    }
  } else if (segments[1] === PATH_SEGMENTS.CATEGORY) {
    const splitAtCategory = segments.length > 2 ? segments[2].split('_') : [];
    const categoryKey = segments.at(2);

    trail.push({
      name: segments.at(1) ?? '',
      href: `${ROUTES.CATEGORY_ROUTE}/${splitAtCategory.at(0)}`,
      isSearchable: true,
    });
    if (categoryKey) {
      trail.push({ name: categoryKey, href: currentPath, isCategory: true, isSearchable: true });
    }
  } else if (segments[1] === PATH_SEGMENTS.SEARCH_RESULT) {
    trail.push({ name: translate('header.search-results'), href: currentPath });
  } else if (segments[1] === PATH_SEGMENTS.PRODUCT_DETAIL) {
    const filteredParent = parentRoute.filter((i) => !i?.isProduct);
    const productKey = segments.length > 2 ? decodeURIComponent(segments[3]) : '';
    trail.push(...filteredParent, { name: capitalize(productKey.replace(/_/g, ' ')), isProduct: true });
  } else if (segments[1] === PATH_SEGMENTS.RETAILER_STORE_ROUTE) {
    const retailerName = decodeURIComponent(segments[2]);
    const filteredParent = parentRoute.filter((i) => !i?.isRetailer);
    trail.push(...filteredParent, { name: capitalize(retailerName), isRetailer: true });
  }

  return trail;
}

export function isHomePage(pathname: string) {
  const segments = getPathSegments(pathname);

  //With or without locale
  if (segments.length <= 1) {
    return true;
  }
  return false;
}

function capitalize(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
